import Interveners from '@/components/AccountConfig/Interveners/index.vue';
import SignatureType from '@/components/AccountConfig/SignatureType/index.vue';
import Beneficiaries from '@/components/AccountConfig/Beneficiaries/index.vue';
import BankAccounts from '@/components/AccountConfig/BankAccounts/index.vue';
import infiniteScroll from 'vue-infinite-scroll';
import Associates from '@/components/AccountConfig/Associates/index.vue';
import MailingType from '@/components/AccountConfig/MailingType/index.vue';
import Configuration from '@/components/AccountConfig/Configuration/index.vue';
import newAccountBanner from '@/components/newAccountBanner/index.vue';
import LZString from 'lz-string';

export default {
    name: 'AccountConfig',

    components: {
        Associates,
        BankAccounts,
        Beneficiaries,
        Configuration,
        Interveners,
        MailingType,
        SignatureType,
        newAccountBanner
    },

    directives: { infiniteScroll },

    data() {
        return {
            intervener: {},
            accounts: [],
            // Pagination flag
            firstLoad: true,
            // Infinite scroll loading flag
            isLoading: false,
            metadata: {},
            uuidAddingAlias: undefined,
            alias: '',
            configuration: {}
        };
    },

    created() {
        const raw = localStorage.getItem('PACOUS');

        try {
            const decompressed = LZString.decompressFromUTF16(raw);
            if (decompressed) {
                this.intervener = JSON.parse(decompressed).private_area.intervener;
            } else {
                // Fallback al formato base64 antiguo
                this.intervener = JSON.parse(
                    decodeURIComponent(escape(window.atob(raw)))
                ).private_area.intervener;
            }
        } catch (e) {
            console.error('❌ Error al descomprimir PACOUS:', e);
            this.intervener = {}; // Fallback en caso de error
        }
    },

    computed: {
        accountTitle() {
            return account => {
                let title = account.account_data.alias_account
                    ? `${account.account_data.alias_account} (${account.account_data.id_object})`
                    : account.account_data.id_object;

                if (account.is_hidden_account) title += ' - (OCULTA)';

                return title;
            };
        }
    },

    methods: {
        editAlias(uuidAccount, alias) {
            this.uuidAddingAlias = uuidAccount;
            this.alias = alias;
        },

        updateAlias(uuidAccount) {
            this.isLoading = true;

            let body = {
                alias_account: this.alias
            };

            this.$accountService
                .updateAccount({}, body, uuidAccount)
                .then(() => {
                    this.isLoading = false;
                    this.uuidAddingAlias = '';

                    this.accounts.map(account => {
                        if (account.account_data.uuid === uuidAccount)
                            account.account_data.alias_account = this.alias;
                    });

                    // Success notification
                    this.$bvToast.toast('Se ha actualizado correctamente', {
                        title: 'Actualizado',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 10000,
                        variant: 'success'
                    });
                })
                .catch(err => {
                    this.isLoading = false;

                    this.$bvToast.toast(`${err.message}`, {
                        title: 'Error',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 10000,
                        variant: 'danger'
                    });

                    console.error(err);
                });
        },

        // Infinite scroll
        loadMore() {
            if (this.firstLoad) {
                this.isLoading = true;
                this.firstLoad = false;

                this.$intervenerService
                    .getIntervenerAccounts({}, this.intervener.uuid, 0, 10, true)
                    .then(response => {
                        this.accounts = response.data.intervener_accounts;
                        this.metadata = response.metadata;
                        this.isLoading = false;
                    })
                    .catch(error => console.error(error));
            } else if (this.metadata.paging.offset < this.metadata.paging.num_pages - 1) {
                this.isLoading = true;

                this.$intervenerService
                    .getIntervenerAccounts(
                        {},
                        this.intervener.uuid,
                        this.metadata.paging.offset + 1,
                        10,
                        true
                    )
                    .then(response => {
                        this.accounts = this.accounts.concat(response.data.intervener_accounts);
                        this.metadata = response.metadata;
                        this.isLoading = false;
                    })
                    .catch(error => console.error(error));
            }
        },
        updateAccountDraftData(updatedAccount) {
            this.accounts = this.accounts.map(account => {
                if (account.uuid_account === updatedAccount.uuid) {
                    account.account_data.draft_data = updatedAccount.draft_data;
                }
                return account;
            });
        },

        updatedConfiguration() {
            // Se vacia en la store la evolución de cuentas, porque hay sitios en los que si
            // ya están en la store, los carga de ahí. Al vaciarlo, en esos sitios se hace una petición
            // para obtener esos valores, y así ya obtiene los datos de cuentas filtrando las cuentas ocultas
            const admin = localStorage.getItem('ADMIN');
            const dni = localStorage.getItem('DNI');

            const serviceGetMe = admin
                ? this.$adminusersService.getMe(dni)
                : this.$userService.getMe();
            this.$store.dispatch('setAccountsEvolutions', []);

            serviceGetMe.then(async meResponseData => {
                if (
                    meResponseData &&
                    meResponseData.private_area &&
                    meResponseData.private_area.intervener
                ) {
                    const intervener = meResponseData.private_area.intervener;
                    const accounts = meResponseData.private_area.accounts;

                    this.$store.dispatch('setIntervener', intervener);
                    this.$store.dispatch('setIntervenerAccounts', accounts);

                    this.firstLoad = true;
                    this.loadMore();
                    this.$bvToast.toast('Se ha actualizado correctamente', {
                        title: 'Actualizado',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 10000,
                        variant: 'success'
                    });
                }
            });
        }
    }
};
